import { DiscordContentFrameCommunicationHandler } from '../../../shared/scripts/discord/DiscordContentFrameCommunicationHandler.ts';
import { DiscordInviteShareHelper } from '../../../shared/scripts/discord/DiscordInviteShareHelper.ts';
import { DiscordLinkInterceptor } from '../../../shared/scripts/discord/DiscordLinkInterceptor.ts';
import { UIDLoadingScreen } from '../../../shared/scripts/discord/UIDLoadingScreen.ts';
import { DiscordCommand } from '../../../../shared/DiscordActivityTypes.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { uiManager } from '../EntryMobile.ts';
export class UIMDiscordActivityController {
    static getInstance() {
        if (!UIUtilsEjsVariables.isUserOnDiscordMobile) throw new Error('Not on Discord Mobile Activity');
        if (UIMDiscordActivityController.instance == undefined) UIMDiscordActivityController.instance = new UIMDiscordActivityController();
        return UIMDiscordActivityController.instance;
    }
    get voiceChannelId() {
        return this.communicationHandler.voiceChannelId;
    }
    get serverProfile() {
        return this.communicationHandler.serverProfile;
    }
    get inDiscordServer() {
        return this.communicationHandler.inDiscordServer;
    }
    get canInviteFriends() {
        return this.communicationHandler.userPermissions.canInviteFriends;
    }
    get referralOrReactivationType() {
        return this.communicationHandler.referralTypeId;
    }
    get isInitialLoad() {
        return this.communicationHandler.isInitialLoad;
    }
    async waitForAuthentication() {
        await this.communicationHandler.waitToBeReady();
        await this.communicationHandler.sendMessageToMount({
            command: DiscordCommand.SetOrientation,
            data: {
                orientation: UIUtilsEjsVariables.discordActivityMobileOrientation
            }
        });
    }
    hideLoadingScreen() {
        this.loadingScreen.hideBackground();
    }
    inviteFriendsToRoom(roomId) {
        DiscordInviteShareHelper.inviteFriendsToRoom(this.communicationHandler, {
            inDiscordServer: this.inDiscordServer,
            canInviteFriends: this.canInviteFriends,
            roomId: roomId
        });
    }
    openInviteFriendsDialogIfAllowed() {
        DiscordInviteShareHelper.inviteFriendsIfAllowed(this.communicationHandler, {
            inDiscordServer: this.inDiscordServer,
            canInviteFriends: this.canInviteFriends
        });
    }
    shareStoreReferral(referralReward) {
        DiscordInviteShareHelper.shareStoreReferral(this.communicationHandler, referralReward);
    }
    constructor(){
        this.communicationHandler = new DiscordContentFrameCommunicationHandler();
        this.loadingScreen = new UIDLoadingScreen();
        this.linkInterceptor = new DiscordLinkInterceptor((url)=>this.communicationHandler.openExternalLink(url), (link)=>uiManager.singletonPageController.navigateToHref(link));
        this.linkInterceptor.init();
    }
}
